module.exports = __webpack_public_path__ + "static/10-woman-phone-d6d6c9c0d9d505575393c2298fb5bd17.png";